export const enUS_profile = {
  'app.user.profile.email': 'Email',
  'app.user.profile.enterEmailMessage': "Please enter user's email!",
  'app.user.profile.role': 'Role',
  'app.user.profile.selectRoleMessage': "Please select user's role!",
  'app.user.profile.role.admin': 'Admin',
  'app.user.profile.role.staff': 'Staff',
  'app.user.profile.fullName': 'Full Name',
  'app.user.profile.phone': 'Phone',
  'app.user.profile.invalidPhoneMessage': 'Phone number is invalid!',
  'app.user.profile.title': 'Profile',
  'app.user.profile.edit': 'Edit',
  'app.user.profile.logout': 'Logout',
  'app.user.profile.cancel': 'Cancel',
  'app.user.profile.editProfile': 'Edit Profile',
  'app.user.profile.editProfileSuccess': 'Update profile successfully!',
  'app.user.profile.save': 'Save'
};
